module.exports = __webpack_public_path__ + "static/media/LinkedIn.89b27c6d.svg";